// Returns the current URL with a single query param set (or removed when the
// value is blank), leaving every other param — e.g. the report's `period` —
// untouched. Pure and side-effect free so it is trivially unit-testable.
export function buildFilteredUrl(currentUrl: string, param: string, value: string): string {
  const url = new URL(currentUrl);

  if (value) {
    url.searchParams.set(param, value);
  } else {
    url.searchParams.delete(param);
  }

  return url.toString();
}
